import {PluginsContainer} from './components/plugins-container';

export default {
    component: PluginsContainer
};
